<div class="service-details-container">
  <div class="breadcrumb-header">
    <div class="breadcrumb">
      <span class="text-muted" routerLink="/company-admin/billing-payments">{{ 'dash.billingTitle' | translate }}</span>
      <i class="bi bi-chevron-right mx-2 text-muted" style="font-size: 12px;"></i>
      <span>{{ 'dash.jobPosting' | translate }}</span>
    </div>
    <button class="btn-back" routerLink="/company-admin/billing-payments">
      <i class="bi bi-arrow-left"></i> {{ 'dash.backToBillingShort' | translate }}
    </button>
  </div>

  <div class="page-title">
    <h1>{{ 'dash.jobPosting' | translate }} <span class="badge low-balance-badge">{{ 'dash.lowBalance' | translate }}</span></h1>
    <p class="subtitle">{{ 'dash.currentPackageActive' | translate }}</p>
  </div>

  <div class="main-layout">
    <!-- Main Package Card -->
    <div class="card package-card">
      <div class="card-header-flex">
        <div>
          <p class="label">{{ 'dash.currentPackage' | translate }}</p>
          <h2>{{ 'dash.activeService' | translate }}</h2>
          <p class="sub-text">{{ 'dash.creditsCount' | translate:{ count: 20 } }}</p>
        </div>
        <div class="stats-right">
          <div class="stat-box">
            <span class="stat-num">16</span>
            <span class="stat-label">{{ 'dash.used' | translate }}</span>
          </div>
          <div class="stat-box">
            <span class="stat-num brown-text">4</span>
            <span class="stat-label">{{ 'dash.remaining' | translate }}</span>
          </div>
        </div>
      </div>

      <div class="progress-section">
        <div class="progress-labels">
          <span>{{ 'dash.creditsUsed' | translate:{ used: 16, total: 20 } }}</span>
          <span class="remaining brown-text">{{ 'dash.remainingCount' | translate:{ count: 4 } }}</span>
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar brown-bg" style="width: 80%"></div>
        </div>
        <span class="used-text">{{ 'dash.percentUsed' | translate:{ percent: 80 } }}</span>
      </div>

      <div class="divider"></div>

      <div class="details-grid">
        <div>
          <p class="label">{{ 'dash.purchaseDate' | translate }}</p>
          <p class="value">02 Aug 2026</p>
        </div>
        <div>
          <p class="label">{{ 'dash.amountPaid' | translate }}</p>
          <p class="value">EGP 4,200</p>
        </div>
      </div>

      <div class="actions mt-4">
        <button class="btn-gradient">{{ 'dash.purchaseMore' | translate }}</button>
      </div>
    </div>

    <!-- Usage Overview Card -->
    <div class="card usage-card">
      <h3 class="card-title">{{ 'dash.usageOverview' | translate }}</h3>
      
      <div class="usage-list">
        <div class="usage-item">
          <span class="usage-label">{{ 'dash.totalPurchased' | translate }}</span>
          <span class="usage-value">20</span>
        </div>
        <div class="usage-item">
          <span class="usage-label">{{ 'dash.used' | translate }}</span>
          <span class="usage-value">16</span>
        </div>
        <div class="usage-item">
          <span class="usage-label">{{ 'dash.remaining' | translate }}</span>
          <span class="usage-value brown-text">4</span>
        </div>
      </div>

      <p class="usage-info-text mt-4">
        {{ 'dash.usageCredits' | translate }}
      </p>
    </div>

    <!-- Purchase Details Card -->
    <div class="card">
      <h3 class="card-title">{{ 'dash.purchaseDetails' | translate }}</h3>
      
      <div class="purchase-info">
        <div class="info-row">
          <span class="info-label">{{ 'dash.reference' | translate }}</span>
          <span class="info-value">UPC-JOB-20260802-0198</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ 'dash.purchaseDate' | translate }}</span>
          <span class="info-value">02 Aug 2026</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ 'dash.amountPaid' | translate }}</span>
          <span class="info-value">EGP 4,200</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ 'dash.paymentStatus' | translate }}</span>
          <span class="badge active-badge">{{ 'dash.paid' | translate }}</span>
        </div>
      </div>

      <button class="btn-outline-gray mt-4">
        <i class="bi bi-file-earmark-text"></i> {{ 'dash.viewInvoice' | translate }}
      </button>
    </div>

    <!-- Recent Activity Card -->
    <div class="card">
      <div class="card-header-flex">
        <h3 class="card-title m-0">{{ 'dash.recentActivityShort' | translate }}</h3>
        <a href="#" class="view-all">{{ 'dash.viewBillingHistory' | translate }}</a>
      </div>
      
      <div class="activity-list mt-4">
        <div class="activity-item">
          <div class="activity-left">
            <h4>{{ 'dash.jobPostingCredits' | translate }}</h4>
            <p>02 Aug 2026</p>
          </div>
          <div class="activity-right">
            <span class="amount">EGP 4,200</span>
            <span class="badge active-badge">{{ 'dash.paid' | translate }}</span>
          </div>
        </div>
        <div class="activity-divider"></div>
        
        <div class="activity-item">
          <div class="activity-left">
            <h4>{{ 'dash.jobPostingCredits' | translate }}</h4>
            <p>11 Jul 2026</p>
          </div>
          <div class="activity-right">
            <span class="amount">EGP 2,100</span>
            <span class="badge pending-badge">{{ 'dash.pending' | translate }}</span>
          </div>
        </div>
        <div class="activity-divider"></div>
        
        <div class="activity-item">
          <div class="activity-left">
            <h4>{{ 'dash.jobPostingCredits' | translate }}</h4>
            <p>14 Jun 2026</p>
          </div>
          <div class="activity-right">
            <span class="amount">EGP 2,100</span>
            <span class="badge failed-badge">{{ 'dash.failed' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
